import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  formDataPostRequest,
  formDataPutRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getColumnsByScreenId(screenId) {
  return getRequest(`Screen/${screenId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getUserPreferencesByScreenId(screenId) {
  return getRequest(`Screen/preferences/${screenId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateColumnOrderById(data) {
  return putRequest(`Screen/update/column/order`, data, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateColumnPreferencesByColumnId(data) {
  return putRequest(`Screen/update/user/preferences`, data, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const screenService = {
  getColumnsByScreenId,
  getUserPreferencesByScreenId,
  updateColumnOrderById,
  updateColumnPreferencesByColumnId,
};
